import { z } from 'zod/mini'

export const resetSchema = z.object({
  token: z.string(),
})
